import type { RouteObject } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3402, { U3402ROLES } from './U3402';
import U3402StandaloneScreen from './components/U3402StandaloneScreen';

const U3402Routes: RouteObject[] = [
  {
    path: 'U3402',
    element: <U2000RequireRole allowedRoles={[U3402ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3402 />,
        children: [{ index: true, element: <U3402StandaloneScreen /> }],
      },
    ],
  },
];

export default U3402Routes;
